import React from "react";
import { QIInput } from "../QIInput";

export const QITimePicker = ({ label, value, onChange, className = "", ...props }) => {
  const match = /^(0?[1-9]|1[0-2]):([0-5]\d) (AM|PM)$/.exec(value || "");
  const nativeValue = match
    ? `${String(Number(match[1]) % 12 + (match[3] === "PM" ? 12 : 0)).padStart(2, "0")}:${match[2]}`
    : "";

  return (
    <QIInput
      {...props}
      className={`qi-time-picker ${className}`}
      label={label}
      aria-label={label}
      type="time"
      value={nativeValue}
      onChange={(event) => {
        const time = event.target.value;
        if (!time) return onChange("");
        const [hours, minutes] = time.split(":");
        const hour = Number(hours);
        onChange(`${String(hour % 12 || 12).padStart(2, "0")}:${minutes} ${hour < 12 ? "AM" : "PM"}`);
      }}
    />
  );
};
